import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation updateTakMutation(\n    $taskID: ID\n    $oldStatusCode: String\n    $newStatusCode: String\n    $lat: String\n    $lon: String\n  ) {\n    updateTaskStatus(\n      taskID: $taskID\n      oldStatusCode: $oldStatusCode\n      newStatusCode: $newStatusCode\n      lat: $lat\n      lon: $lon\n    )\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
export var updateTaskStatusMutation = gql(_templateObject());